import script from "./header.vue?vue&type=script&setup=true&lang=ts"
export * from "./header.vue?vue&type=script&setup=true&lang=ts"

import "./header.vue?vue&type=style&index=0&id=772f3248&scoped=true&lang=stylus"

import exportComponent from "D:\\Repository\\Zidan\\pc-customer-admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-772f3248"]])

export default __exports__